var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10000,
    height: 800,
    viewBox: "0 0 10000 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1017_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9320.5 -10L9976.5 359V440L9320.5 806H-95.5V-10H9320.5Z",
    fill: "#1ECD97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9999.93 399.601C9999.92 408.489 9997.55 417.215 9993.06 424.882C9988.57 432.55 9982.11 438.883 9974.36 443.229L9446.5 738.829C9437.64 743.857 9427.44 746.033 9417.29 745.059C9407.15 744.086 9397.55 740.012 9389.8 733.39C9381.98 726.855 9376.36 718.069 9373.71 708.227C9371.06 698.385 9371.5 687.965 9374.98 678.385L9465.62 424.601H9701.1C9707.73 424.601 9714.09 421.967 9718.78 417.279C9723.46 412.591 9726.1 406.232 9726.1 399.601C9726.1 392.971 9723.46 386.612 9718.78 381.924C9714.09 377.235 9707.73 374.601 9701.1 374.601H9465.62L9374.98 120.817C9371.56 111.231 9371.14 100.828 9373.79 90.9988C9376.44 81.1697 9382.02 72.3827 9389.8 65.8121C9397.57 59.2414 9407.17 55.2002 9417.3 54.2284C9427.43 53.2566 9437.62 55.4007 9446.5 60.3739L9974.36 355.973C9982.11 360.321 9988.57 366.653 9993.06 374.321C9997.55 381.988 9999.92 390.714 9999.93 399.601Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1017_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10000,
    height: 800,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMask);
export default __webpack_public_path__ + "static/media/send_mask.ed6ddbaa0fef08b2a0485ea05fcab514.svg";
export { ForwardRef as ReactComponent };